import classNames from "classnames/bind";
import styles from "./Statistic.module.css";
import { useContext, useState } from "react";
import { LisencePlateManagerContext } from "../../../../contexts";
import { Alert, Button, SelectBox, SelectBoxItem } from "../../../../components";
import AreaChart from "../../../Dashboard/ServiceControl/AreaChart";

const cx = classNames.bind(styles);

function StatisticAI() {
    const { nameService, cameraCode } = useContext(LisencePlateManagerContext);
    const [alert, setAlert] = useState(false);

    return (
        <div className={cx('wrapper')}>
            {alert && <Alert title={'Chức năng đang phát triển'} onClose={() => setAlert(false)} onOk={() => setAlert(false)}/>}
            {cameraCode ? (
                <>
                    <div className={cx('chart')}>
                        <p className={cx('label-box')}>Biểu đồ</p>
                        <AreaChart title={'Biểu đồ thống kê số lượng sự kiện'} serviceCode={'20230222000000000006'} cameraCode={cameraCode} />
                    </div>
                    <div className={cx('action-control')}>
                        <p className={cx('label-box')}>Xuất báo cáo</p>
                        <div className={cx('type-docs')}>
                            <label className={cx('name')}>Định dạng</label>
                            <div className={cx('select-box')}>
                                <SelectBox values={'Excel'}>
                                    <SelectBoxItem label={'Excel'} value={'1'} />
                                </SelectBox>
                            </div>
                        </div>
                        <div className={cx('export-button')}>
                            <Button title={'Xuất báo cáo'} onClick={() => setAlert(true)} />
                        </div>
                    </div>
                </>
            ) : (
                <div className={cx("empty")}>
                    <p>Vui lòng lựa chọn camera để  xem thống kê {nameService?.toLowerCase()}!</p>
                </div>
            )}
        </div>
    )
}

export default StatisticAI;